module.exports = __webpack_public_path__ + "static/uottawa_branch_logo-2-7fcbcfefd524caccb1390978ecc6eabd.png";